export interface IOsiSystemReportsWidgetViewModel {
  // OSI-798: список отчётов стал вычисляемым (computed-геттер в VM) — часть отчётов скрывается
  // в зависимости от схемы расчёта дома (Osi.PrintMonth). Снаружи только для чтения.
  readonly reports: any[];
  isLoading: boolean;
  // Состояние чекбокса «Свернуть дочерние помещения» ПО ОТЧЁТУ (per-report).
  // Словарь { [reportId]: boolean } — чекбоксы разных отчётов независимы.
  collapseByReport: Record<number, boolean>;
  // Чтение per-report состояния чекбокса для конкретного отчёта
  isCollapseFor: (reportId: number) => boolean;
  // Сеттер per-report состояния чекбокса
  setCollapseFor: (reportId: number, value: boolean) => void;
  // OSI-806: есть ли у ОСИ дочерние помещения (паркинги/кладовки).
  // Если нет — колонка 'collapse' с чекбоксами «Свернуть дочерние помещения» не добавляется
  // в грид вообще (ни для одного из трёх отчётов).
  hasChildAbonents: boolean;
  onDownloadReportClick: (report: any) => Promise<void>;
}

export const IOsiSystemReportsWidgetVmToken = Symbol.for('IOsiSystemReportsWidgetViewModel');
